import React from 'react';
import get from 'lodash/get';
import { SalesRow } from './sales-row';
import { DeductionsRow } from './deductions-row';
import { TotalRow } from './total-row';
import { DividerRow } from './divider-row';
import { ProcessingFeeRow } from './processing-fee-row';
import { TotalPaidRow } from './total-paid-row.jsx';
import { ColumnHeadingRow } from './column-heading-row';
import { TaxableReceiptsGroupComponent } from './taxable-receipts-group-component';
import { TotalPaymentDueRow } from './total-payment-due-row';
import { SpacerRow } from './spacer-row';

export function TaxSummaryTableComponent({ data }) {
  const salesLabel = get(data, 'salesAndDeductions.salesLabel');
  const deductionsLabel = get(data, 'salesAndDeductions.deductionsLabel');
  const totalLabel = get(data, 'salesAndDeductions.totalLabel');
  const periodLabel = get(data, 'periodLabel');
  const providers = get(data, 'providers');
  const taxableReceipts = get(data, 'taxableReceipts');
  const taxableReceiptsProviderValues = get(data, 'salesAndDeductions.taxableReceiptsProviderValues');
  const salesProviderValues = get(data, 'salesAndDeductions.salesProviderValues');
  const deductionsProviderValues = get(data, 'salesAndDeductions.deductionsProviderValues');
  const showDeductions = Array.isArray(deductionsProviderValues) && deductionsProviderValues.length;
  const totalPaymentDueProviderValues = get(data, 'totalPaymentDue.providerValues');
  const processingFee = get(data, 'totalPaymentDue.processingFee');
  const totalPaid = get(data, 'totalPaymentDue.total');
  const showProcessingFee = get(data, 'showProcessingFee');
  const showTotalPaid = get(data, 'showTotalPaid');

  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <ColumnHeadingRow providers={providers} />
        <SalesRow providers={providers} salesLabel={salesLabel} salesProviderValues={salesProviderValues} />
        {
          showDeductions &&
          <DeductionsRow providers={providers} deductionsLabel={deductionsLabel} deductionsProviderValues={deductionsProviderValues} />
        }
        <DividerRow colspan={providers.length + 1} />
        <TotalRow providers={providers} totalLabel={totalLabel} taxableReceiptsProviderValues={taxableReceiptsProviderValues} />
      </tbody>
      {
        taxableReceipts.map((group, index) => (
          <TaxableReceiptsGroupComponent key={`taxableReceiptsGroup_${index}`} group={{ ...group, index }} providers={providers} />
        ))
      }
      <tbody>
        <DividerRow colspan={providers.length + 1} />
        <TotalPaymentDueRow providers={providers} periodLabel={periodLabel} totalPaymentDueProviderValues={totalPaymentDueProviderValues} />
        <DividerRow colspan={providers.length + 1} />
        {showProcessingFee && (
          <>
            <ProcessingFeeRow processingFee={processingFee} providers={providers} />
            <SpacerRow colspan={providers.length + 1} paddingBottom={'10px'} />
          </>
        )}
        {showTotalPaid && <TotalPaidRow totalPaid={totalPaid} providers={providers} />}
      </tbody>
    </table>
  );
}
